import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-financialinstitution',
  templateUrl: './financialinstitution.component.html',
  styleUrls: ['./financialinstitution.component.scss'],
})
export class FinancialinstitutionComponent {}
